export { default as About } from './About'
export { default as Clients } from './Clients'
export { default as Contact } from './Contact'
export { default as Dot } from './Dot'
export { default as Hero } from './Hero'
export { default as Navigation } from './Navigation'
export { default as SelectedWork } from './SelectedWork'
export { default as Products } from './Products'
export { default as Services } from './Services'
export { default as Team } from './Team'
export { default as Footer } from './Footer'
export { default as Sayonara } from './Sayonara'



// WEBPACK FOOTER //
// ./src/components/index.js